// removed by extract-text-webpack-plugin
module.exports = {"container":"Urgency__container__m1q19","icon":"Urgency__icon__1iBpi","content":"Urgency__content__1qN5Q","title":"Urgency__title__3yLLY","text":"Urgency__text__3F3FM"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Sidebar/styles/Urgency.scss
// module id = 3061
// module chunks = 4